/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
	
	
	jQuery(".hamburger").click(function() {
		jQuery('.hamburger').toggleClass("is-active");
	});	 
	
  	//Featherlightgallery
	jQuery('.gallery').featherlightGallery({
					gallery: {
						fadeIn: 300,
						fadeOut: 300, 
					},		
					openSpeed:    300,
					closeSpeed:   300
	});  
	

    jQuery('#submit').click(function() {
           if(jQuery('#kennwort').val()==jQuery('#galleriekw').val()){
           	
           	jQuery('.gallerie').removeClass('deak');
           	jQuery('.save').fadeOut();	
           	
			// layout Isotope after each image loads
			jQuery('.gallerie').imagesLoaded().progress( function() {
			  jQuery('.gallerie').isotope('layout');
			}); 	           	

           }else{
           	alert("Das Passwort ist leider falsch, sie können die Gallerie leider nicht aufrufen");
           }

        }
    );

	
	
	
	
  	
	jQuery(".js-off-canvas-overlay.is-overlay-fixed").click(function() {
		jQuery('.hamburger').toggleClass("is-active");
	});			

	jQuery('.blogin').isotope({
	  // options
	  itemSelector: '.grid-item',
	});
	
	jQuery('.gallerie').isotope({
		itemSelector: '.grid-item',
	});
	
	// layout Isotope after each image loads
	jQuery('.blogin').imagesLoaded().progress( function() {
	  jQuery('.blogin').isotope('layout');
	}); 
	// layout Isotope after each image loads
	jQuery('.gallerie').imagesLoaded().progress( function() {
	  jQuery('.gallerie').isotope('layout');
	}); 	
	
}); 